export default __webpack_public_path__ + "a34eb151300825e56a720df6732eab8b.woff2";